<!--  -->
<template>
  <div class="login">
    <el-dialog
      :visible.sync="visible"
      width="400px"
      :close-on-click-modal="false"
      :before-close="onClose"
      :show-close="closed"
      :close-on-press-escape="false"
      top="22vh"
      :modal-append-to-body="false"
    >
      <div style="color:#fff;position: absolute;top:-65px;font-size:24px;left:77px;">
        <img class="logo" src="../assets/logo2xL.png" alt />
        <el-divider direction="vertical" class="ding"></el-divider>通行证
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="短信登录" name="1">
          <el-form :rules="rules" :model="ruleForm" ref="rulePhone">
            <el-form-item label prop="phoneNum" style="margin-bottom:20px">
              <el-input
                placeholder="请输入手机号"
                prefix-icon="el-icon-user"
                v-model="ruleForm.phoneNum"
                clearable
                maxlength="11"
              ></el-input>
              <!-- @blur="phoneMessage" -->
            </el-form-item>
            <el-form-item label prop="phoneCode" style="margin-bottom:0">
              <div class="password">
                <el-input
                  placeholder="验证码"
                  prefix-icon="el-icon-lock"
                  v-model="ruleForm.phoneCode"
                  clearable
                  maxlength="6"
                ></el-input>
                <el-button type="primary" :disabled="disabled" plain @click="getCode(1)">
                  获取验证码
                  <span class="countDown" v-show="codeShow">{{ count }}S</span>
                </el-button>
              </div>
            </el-form-item>
          </el-form>
          <!-- <div class="drag" ref="dragDiv">
            <div class="drag_bg"></div>
            <div class="drag_text">{{ confirmWords }}</div>
            <div 迭代版本滑块
              ref="moveDiv"
              @mousedown="mousedownFn($event)"
              :class="{ handler_ok_bg: confirmSuccess }"
              class="handler handler_bg"
              style="position: absolute;top: 0px;left: 0px;"
            ></div> 
          </div>-->

          <el-button class="login" @click="login(1, 'rulePhone')">登录</el-button>
        </el-tab-pane>
        <el-tab-pane label="密码登录" name="2">
          <el-form :rules="rules" :model="ruleForm" ref="ruleEmail">
            <el-form-item label prop="email" style="margin-bottom:20px">
              <el-input
                placeholder="请输入手机号"
                prefix-icon="el-icon-user"
                v-model="ruleForm.account"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label prop="emailCode" style="margin-bottom:0">
              <el-input
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                v-model="ruleForm.passCode"
                clearable
                maxlength="20"
                show-password
                onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button class="login" type="primary" @click="login(2, 'ruleEmail')">登录</el-button>
        </el-tab-pane>
      </el-tabs>
      <div class="wx">
        <p class="txt2" @click="toTxt">未注册用户关注牵星出海公众号后自动注册，注册即代表同意《牵星出海用户使用许可协议》</p>
        <el-divider style="color:#a0a0a0;">第三方账号登录</el-divider>
        <button @click="wxcode">
          <img src="../assets/wx.png" alt />
        </button>
      </div>
      <div class="codeBox" v-show="wxshow">
        <span class="close" @click="close">返回</span>
        <div>
          <img v-if="wximg" :src="wximg" alt />
        </div>
        <p class="txt1">微信扫码登录</p>
        <p
          class="txt2"
          style="width:255px;"
          @click="toTxt"
        >未注册用户关注牵星出海公众号后自动注册，注册即代表同意《牵星出海用户使用许可协议》</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
import tool from '../tool/tool'
import md5 from 'js-md5'
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    visible: Boolean,
    closed,
  },
  components: {},
  data() {
    //这里存放数据
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[23456789]\d{9}$/
      if (!value) {
        this.disabled = true
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
          this.disabled = true
        } else {
          if (phoneReg.test(value)) {
            this.disabled = false
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
            this.disabled = true
          }
        }
      }, 100)
    }
    //邮箱验证
    var checkEmail = (rule, value, callback) => {
      const reg =
        /^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (reg.test(value)) {
          this.disabled = false
          callback()
        } else {
          callback(new Error('邮箱格式不正确'))
          this.disabled = true
        }
      }, 100)
    }
    return {
      wximg: null, //微信登录二维码
      wxshow: false,
      ruleForm: {
        phoneNum: '', //登录手机号
        account: '', //登录账号
        phoneCode: '', //手机验证
        passCode: '', //密码
      },
      disabled: true, //验证码按钮可用状态
      loginDisabled: false, //登录按钮可用状态
      codeShow: false, //倒计时显示
      count: '', //显示时的文字内容
      timer: null, //验证码倒计时
      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveStata: false /*触发拖动状态  判断*/,
      maxwidth: '' /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: '拖动滑块验证' /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      activeName: '1', //默认tabs
      userInfo: {},
      rules: {
        phoneNum: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
        phoneCode: [
          { required: true, message: '请输入验证码', trigger: 'change' },
        ],
        account: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
        passCode: [
          { required: true, message: '请输入密码', trigger: 'change' },
        ],
      },
      lockReconnect: false, //是否真正建立连接
      timeout: 58 * 1000, //秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toTxt() {
      //通用页面 传id 读取不同的内容
      const params = { numbercms: 102622 }
      let routeData = this.$router.resolve({
        name: 'publicPage',
        query: params,
      })
      window.open(routeData.href, '_blank')
    },
    close() {
      this.wxshow = false
      this.ws.close()
    },
    wxcode() {
      this.wxshow = true
      //ws://192.168.2.198:8082/
      let wsuri = 'ws://182.61.21.235/fy/socket/massage'
      //192.168.0.196:8080
      this.ws = new WebSocket(wsuri)
      this.ws.onopen = this.onopen
      this.ws.onmessage = this.onmessage
      this.ws.onclose = this.onclose
      this.ws.onerror = this.onerror
    },
    reconnect() {
      //重新连接
      var that = this
      if (that.lockReconnect) {
        return
      }
      that.lockReconnect = true
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum)
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.wxcode()
        that.lockReconnect = false
      }, 5000)
    },
    reset() {
      //重置心跳
      var that = this
      //清除时间
      clearTimeout(that.timeoutObj)
      clearTimeout(that.serverTimeoutObj)
      //重启心跳
      that.start()
    },
    start() {
      //开启心跳
      var self = this
      self.timeoutObj && clearTimeout(self.timeoutObj)
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.ws.readyState == 1) {
          //如果连接正常
          self.ws.send('xtqxch')
        } else {
          //否则重连
          self.reconnect()
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.ws.close()
        }, self.timeout)
      }, self.timeout)
    },
    onopen() {
      //开启心跳
      this.start()
    },
    onmessage(e) {
      //获取websocket推送的数据
      let msg = e.data
      let obj = JSON.parse(msg)
      if (obj.status == 1) {
        //获取微信二维码
        this.wximg =
          'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + obj.data
      }
      if (obj.status == 2) {
        //获取微信二维码
        tool.saveCookie('qxchuhai', obj.data.value2, 1)
        tool.saveCookie('user', obj.data.value, 1)
        this.$message({
          message: '登录成功，欢迎您',
          type: 'success',
          offset: 50,
        })
        this.$emit('update:visible', false)
        this.$emit('result', { wx: 1 })
        //window.location.reload()
      }
      if (obj.status == 5) {
        //心跳超时
        this.ws.close()
      } else {
        //收到服务器信息，心跳重置
        this.reset()
      }
    },
    onclose(e) {
      console.log('连接关闭')
      clearTimeout(this.timeoutObj)
      clearTimeout(this.serverTimeoutObj)
      //重连
      //this.reconnect()
    },
    onerror(e) {
      console.log('出现错误')
      //重连
      //this.reconnect()
    },
    onClose() {
      this.$emit('update:visible', false)
    },
    login(type, formName) {
      if (type == 1) {
        //手机验证码
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              phone: this.ruleForm.phoneNum,
              code: this.ruleForm.phoneCode,
            }
            this.axios
              .post(API_1 + Global.phoneCode, params)
              .then((res) => {
                if (res.data.status == 1) {
                  tool.saveCookie('qxchuhai', res.data.data.code, 1)
                  tool.saveCookie('user', res.data.data.id, 1)
                  this.$message({
                    message: '登录成功，欢迎您',
                    type: 'success',
                    offset: 50,
                  })
                  this.$emit('result', res.data.data)
                  this.$emit('update:visible', false)
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error',
                    offset: 50,
                  })
                }
              })
              .catch((res) => {
                this.$message({
                  message: '登录失败，请稍后再试',
                  type: 'error',
                  offset: 50,
                })
              })
          } else {
            console.log('error!!')
            return false
          }
        })
      } else if (type == 2) {
        //邮箱验证码
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.$qs.stringify({
              phone: this.ruleForm.account,
              password: md5(this.ruleForm.passCode),
            })
            this.axios
              .post(API_1 + Global.pass, params)
              .then((res) => {
                if (res.data.status == 1) {
                  tool.saveCookie('qxchuhai', res.data.data.code, 1)
                  tool.saveCookie('user', res.data.data.id, 1)
                  this.$message({
                    message: '登录成功，欢迎您',
                    type: 'success',
                    offset: 50,
                  })
                  this.$emit('result', res.data.data)
                  this.$emit('update:visible', false)
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error',
                    offset: 50,
                  })
                }
              })
              .catch((res) => {
                this.$message({
                  message: '登录失败，请稍后再试',
                  type: 'error',
                  offset: 50,
                })
              })
          } else {
            console.log('error!!')
            return false
          }
        })
      }
    },
    getCode(type) {
      //点击获取验证码
      this.disabled = true
      const TIME_COUNT = 60 //倒计时60秒
      if (!this.timer) {
        this.count = TIME_COUNT
        this.codeShow = true
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.codeShow = false
            clearInterval(this.timer)
            this.timer = null
            this.disabled = false
          }
        }, 1000)
        if (type == 1) {
          //手机验证码
          let params = this.$qs.stringify({
            phone: this.ruleForm.phoneNum,
          })
          this.axios
            .post(API_1 + Global.phone, params)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message({
                  message: '发送成功，请注意查收验证码',
                  type: 'success',
                  offset: 50,
                })
              } else {
                this.$message({
                  message: '发送失败，请稍后再试',
                  type: 'error',
                  offset: 50,
                })
              }
            })
            .catch((res) => {
              this.$message({
                message: '发送失败，请稍后再试',
                type: 'error',
                offset: 50,
              })
            })
        }
      }
    },
    openLogin() {
      this.dialogFormVisible = true
    },
    phoneMessage() {
      if (this.phone === '') {
        this.$message({
          showClose: true,
          message: '手机号不能为空',
          type: 'warning',
          offset: 50,
        })
      } else {
        if (this.phone !== '') {
          let reg = /^1[23456789]\d{9}$/
          if (!reg.test(this.phone)) {
            this.$message({
              showClose: true,
              message: '请输入有效手机格式',
              type: 'warning',
              offset: 50,
            })
          } else {
            this.disabled = false
          }
        }
      }
    },
    emailMessage() {
      if (this.email === '') {
        this.$message({
          showClose: true,
          message: '邮箱不能为空',
          type: 'warning',
          offset: 50,
        })
      } else {
        if (this.email !== '') {
          let reg =
            /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!reg.test(this.email)) {
            this.$message({
              showClose: true,
              message: '请输入有效的邮箱格式',
              type: 'warning',
              offset: 50,
            })
          } else {
            this.disabled = false
          }
        }
      }
    },
    onSubmit() {
      //跳转搜索页
      this.$router.push({
        path: 'find',
        query: { keyWord: this.input1 },
      })
    },
    mousedownFn: function (e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault() //阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true
        this.beginClientX = e.clientX
      }
    }, //mousedoen 事件
    successFunction() {
      this.confirmSuccess = true
      this.confirmWords = '验证通过'
      if (window.addEventListener) {
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mousemove', this.mouseMoveFn)
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mouseup', this.moseUpFn)
      } else {
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mouseup', () => {})
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left =
        this.maxwidth + 'px'
      document.getElementsByClassName('drag_bg')[0].style.width =
        this.maxwidth + 'px'
    }, //验证成功函数
    mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        let width = e.clientX - this.beginClientX
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName('handler')[0].style.left =
            width + 'px'
          document.getElementsByClassName('drag_bg')[0].style.width =
            width + 'px'
        } else if (width > this.maxwidth) {
          this.successFunction()
        }
      }
    },
    moseUpFn(e) {
      this.mouseMoveStata = false
      var width = e.clientX - this.beginClientX
      if (width < this.maxwidth) {
        document.getElementsByClassName('handler')[0].style.left = 0 + 'px'
        document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px'
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
  //@import url(); 引入公共css类

  .logo {
    width: 125px;
    height: 40px;
  }
  .ding {
    margin: 0 15px 0 20px;
  }
  .el-divider__text {
    color: #a0a0a0;
  }
  .el-tabs {
    /deep/.el-tabs__item {
      color: #999;
      font-size: 16px;
    }
    /deep/.el-tabs__active-bar {
      width: 66px;
    }
    /deep/ .is-active {
      color: #0f4d72;
    }
    /deep/.el-tabs__active-bar {
      background-color: #0f4d72;
    }
  }
  /deep/.el-dialog {
    padding: 0 40px;
    text-align: left;
    border-radius: 8px;
    margin: 22vh auto 0 !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 30px 0;
      .txt2 {
        width: 320px;
        text-align: left;
        margin: 10px auto 0;
        font-size: 12px;
        color: #b0b0b0;
        cursor: pointer;
      }
      .wx {
        text-align: center;
        button {
          background: #fff;
          cursor: pointer;
        }
      }
      .codeBox {
        background: #fff;
        width: 400px;
        height: 440px;
        border-radius: 6px;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 9999;
        padding-top: 50px;
        .close {
          position: absolute;
          top: 10px;
          left: 20px;
          cursor: pointer;
        }
        div {
          width: 230px;
          height: 230px;
          margin: 0 auto;
          text-align: center;
        }
        img {
          width: 230px;
          height: 230px;
          margin-bottom: 20px;
        }
        .txt1 {
          background-image: url('../assets/wx.png');
          background-position: 40px 10px;
          background-repeat: no-repeat;
          background-size: 20px 20px;
          height: 40px;
          line-height: 40px;
          color: #04cb64;
          background-color: #d3f1cb;
          width: 200px;
          margin: 0 auto;
          border-radius: 20px;
          padding: 0 20px;
          font-size: 16px;
          margin-bottom: 20px;
        }
      }
    }
    .drag {
      margin-top: 20px;
      position: relative;
      background-color: #e8e8e8;
      //width: 100%;
      width: 320px;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .handler {
      width: 40px;
      height: 38px;
      border: 1px solid #ccc;
      cursor: move;
    }
    .handler_bg {
      background: #fff
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==')
        no-repeat center;
    }
    .handler_ok_bg {
      background: #fff
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==')
        no-repeat center;
    }
    .drag_bg {
      background-color: #7ac23c;
      height: 40px;
      width: 0px;
    }
    .drag_text {
      position: absolute;
      top: 0px;
      //width: 100%;
      width: 320px;
      text-align: center;
      -moz-user-select: none;
      -webkit-user-select: none;
      user-select: none;
      -o-user-select: none;
      -ms-user-select: none;
    }

    .el-input {
      width: 320px;
      .el-input__inner:focus {
        border-color: #0f4d72;
      }
    }
    .countDown {
      color: red;
      font-size: 16px;
      margin: 0 10px;
    }
    .password {
      //margin-top: 20px;
      .el-input {
        width: 120px;
        margin-right: 10px;
      }
      .el-button {
        background: #0f4d72;
        color: #fff;
        &:hover {
          background: rgba(16, 94, 140, 1);
          color: #fff;
        }
      }
    }
    .login {
      margin-top: 20px;
      width: 320px;
      color: #fff;
      background: #0f4d72;
      border: none;
    }
    .box {
      display: inline-block;
      line-height: 80px;
      height: 80px;
      vertical-align: middle;
      margin-right: 160px;
      .el-input {
        width: 300px;
      }
      .el-button {
        background: transparent;
        margin-left: 50px;
      }
    }
    .el-menu--horizontal {
      border-bottom: transparent;
    }
    .el-menu {
      background: transparent;
      width: 550px;
      margin: 0 auto;
      li {
        height: 80px;
        line-height: 80px;
      }
    }
  }
</style>
